<article *ngIf="listArticle"
         class="data-list-layout">

  <div class="list-wrap">

    <ul>
      <li *ngFor="let article of listArticle"
          (click)="onSelect($event, article.no)"
          [class.on]="selectedNo === article.no">
          <span [innerHTML]="article.title | resize | keepHtml"></span>

        <!-- a class="item-box"
           (click)="onSelect($event, article.no)">

          <div class="info-box">

            <div class="subject-box"
                 [innerHTML]="article.title | resize | keepHtml"></div>
            <div class="con-box"
                 [innerHTML]="article.brief | resize | keepHtml"></div>

          </div>
          <div *ngIf="article.thumbnail"
               class="img-box">
            <img src="{{ article.thumbnail }}" alt="이미지">
          </div>

        </a -->
      </li>

    </ul>
  </div>

</article>
